<template>
    <div style="margin-bottom: 140px;">
        <div style="margin-bottom: 14px;text-align: left">
            <div class="page-header">
                <div class="search-box">
                    <input class="search-box__input" type="text" maxlength="20" v-model="searchValue" placeholder="Пошук" @keyup.enter="search()">
                    <div class="search-box__control">
                        <button type="button" class="search-box__clear" aria-label="Очистити пошук" @click="clearSearch()" v-if="searchValue.length"></button>
                        <button type="button" class="search-box__btn" @click="search()">Пошук</button>
                    </div>
                </div>
            </div>
            <!-- Фільтр за видами — лише в категорії «Піца» (id 1, як на головній сторінці піц) -->
            <PizzaFilters v-if="$v2 && loaded && category && category.id == 1" :products="products" v-model="pizzaKind"/>

            <ul class="subcategory-list">
                <li v-if="parentCategory" class="subcategory-item add-to-card-button" @click="routerToCategoryRoute('category.index', parentCategory.code)">
                    Повернутися до {{ parentCategory.name }}
                </li>
                <li v-for="subcategory in categories" :key="category.id" v-if="subcategory.is_enabled == 1 && category.id == subcategory.parent_id" class="subcategory-item add-to-card-button" @click="routerToCategoryRoute('category.index', subcategory.code)">
                    {{ subcategory.name }}
                </li>
            </ul>
        </div>
        <div v-if="!loaded">
            <img src="@/assets/loading.svg" style="width: 34px;">
        </div>

        <router-view/>
        <div class="products-pizza-container" v-if="loaded" v-show="showProducts">
            <div v-for="product in visibleProducts" :key="product.id">
                <Product :product="product"/>
            </div>
        </div>
    </div>
</template>

<script>
import Product from '@/components/Product.vue'
import PizzaFilters from '@/components/PizzaFilters.vue'
import { pizzaIs } from '@/pizzaKinds'
import axios from "axios";
import Vue from "vue";

export default {
    name: 'home',
    components: {
        Product,
        PizzaFilters
    },
    data() {
        return {
            categories: [],
            parentCategory: null,
            category: null,
            products: [],
            pizzaKind: null,
            loaded: false,
            searchValue: '',
            showProducts: false,
        }
    },

    computed: {
        visibleProducts() {
            if (!this.pizzaKind || !this.category || this.category.id != 1) return this.products;
            return this.products.filter(product => pizzaIs(this.pizzaKind, product));
        }
    },

    watch: {
        $route () {
            this.loadProducts();
        }
    },

    mounted() {
        this.loadProducts();
    },

    methods: {
        loadProducts() {
            document.querySelector('body').style.overflow = '';
            this.pizzaKind = null;

            this.$store.dispatch('getCategories').then(categories => {
                this.categories = categories;

                // Set category
                var routeCode = this.$route.params.code;
                var selectedCategory = null;

                categories.forEach(function (category) {
                    if(category.code == routeCode) {
                        selectedCategory = category;
                        return true;
                    }
                });

                this.category = selectedCategory;
                // !Set category

                // Set parent category
                selectedCategory = null;
                if(this.category.parent_id) {
                    var parent_id = this.category.parent_id;

                    categories.forEach(function (category) {
                        if(category.id == parent_id) {
                            selectedCategory = category;
                            return true;
                        }
                    });
                }
                this.parentCategory = selectedCategory;
                // !Set parent category

                // Search nested categories
                var categoriesIds = [
                    this.category.id
                ];
                var categoryWithSubcategoriesIds = [
                    this.category.id
                ];

                do {
                    var currentCategoryId = categoriesIds.pop();

                    categories.forEach(function (category) {
                        if(category.parent_id == currentCategoryId) {
                            categoriesIds.push(category.id);
                            categoryWithSubcategoriesIds.push(category.id);
                        }
                    });

                } while (categoriesIds.length);
                // !Search nested categories

                // Get nested products
                this.$store.dispatch('getProducts').then(products => {
                    this.products = products.filter((product) => categoryWithSubcategoriesIds.includes(product.category_id));
                    this.loaded = true;

                    setTimeout(() => {
                        this.showProducts = true;
                    }, 500);
                });
                // !Get nested products
            });
        },

        clearSearch() {
            this.searchValue = '';
            this.$store.dispatch('getProducts').then(products => {
                this.products = products.filter((product) => product.category_id == this.category.id);
            });
        },

        search() {
            this.loaded = false;
            this.showProducts = false;

            if(this.searchValue) {
                let search_url = `${Vue.prototype.SERVER_URL}/api/${JSON.parse(localStorage.getItem('locationCityId'))}/products`;
                // «/», «?» чи «#» у пошуку інакше ламають адресу запиту (як у Pizza.vue)
                search_url += '/search/' + encodeURIComponent(this.searchValue);
                search_url += '?category_id=' + this.category.id;

                axios.get(search_url).then(response => {
                    this.products = response.data.products;
                }).catch(e => console.log(e));
            }
            else {
                this.$store.dispatch('getProducts').then(products => {
                    this.products = products.filter((product) => product.category_id == this.category.id);
                });
            }

            this.loaded = true;
            this.showProducts = true;
        },

        routerToCategoryRoute(name, code) {
            if(this.mobNav) {
                this.closeMobNav();
            }
            this.$router.push({name: name, params: {location_city: this.$route.params.locationCity, code: code}});
        },
    }
}
</script>

<style>
.products-pizza-container {
    display: flex;
    flex-flow: wrap;
}

.page-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.page-title {
    font-weight: bold;
    font-size: 2rem;
    margin: 0 14px;
}

.search-box {
    display: flex;
    align-items: center;

    position: relative;

    min-width: 356px;
    max-width: 49%;
    width: 100%;
}

.search-box__input {
    width: 100%;
    min-height: 40px;
    padding: .375rem .75rem;
    border: 1px solid #5C5C5C;
    border-radius: 6px;
}
.search-box__input:focus {
    outline: none;
}

.search-box__control {
    position: absolute;
    top: 0;
    bottom: 0;
    right: -2px;

    display: flex;
    align-items: center;
}

.search-box__clear {
    position: relative;
    min-height: 40px;
    padding: .375rem .75rem;
    border: 0;
    background: none;

    color: #fb3431;
    cursor: pointer;
}

.search-box__clear:before, .search-box__clear:after {
    content: '';
    display: block;

    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    width: 14px;
    height: 2px;
    background: #fb3431;
}

.search-box__clear:after {
    transform: translate(-50%, -50%) rotate(-45deg);
}

.search-box__clear:before {
    transform: translate(-50%, -50%) rotate(45deg);
}

.search-box__btn {
    min-height: 40px;

    padding: 9px 34px;
    border: 1px solid #AB2321;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;

    line-height: 100%;
    font-size: 1.25rem;
    color: #fff;
    font-weight: 500;

    background-color: #AB2321;
    cursor: pointer;
}

.subcategory-list {
    display: flex;
    gap: 8px;

    padding: unset;

    list-style-type: none;
}

.subcategory-item {
    cursor: pointer;
}

@media only screen and (max-width: 1024px) {
    .products-pizza-container {
        flex-direction: column;
    }

    .page-title {
        margin-left: 0;
    }

    .search-box {
        min-width: 100%;
    }
}
</style>